import React, { useState, useEffect, useRef, Fragment } from 'react';

import cx from 'classnames';

import Fonts from '../../../../fonts';
import Content from '../../../../widgets/core/content';
import { useParentWidgetSelectorForType } from '../../../../widgets/core/hooks';

import { CONTENT } from '../../../../../constants/widgetTypes';

import { Dropdown, Form } from 'react-bootstrap';

import styles from './filterDropdown.module.scss';
import TruncatedTextWithTooltip from '../../../../TruncatedTextWithTooltip';
import { injectAktivFallback } from '../../../../widgets/widget.helper';
import compact from 'lodash/compact';
import get from 'lodash/get';
import includes from 'lodash/includes';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import size from 'lodash/size';
import values from 'lodash/values';


const FilterDropdownComponent = ({ className, widgetProps, breakpoint, filterContent, alignment }) => {
  Fonts.useFont(get(widgetProps, 'fonts') || []);

  const wrapperStyles = dropdownButtonWrapperStyles(widgetProps, alignment, breakpoint);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  return (
    <div style={wrapperStyles} className={cx(className, styles.dropdownContainer)}>
      {
        (filterContent && size(filterContent) == 1) &&
        (compact(filterContent) || []).map((filter) => {

          const options = [{
            id: 'all',
            value: 'All'
          }, ...filter.options];

          return options.map((option, index) => {
            return (
              <ButtonTab
                filter={filter}
                option={option}
                widgetProps={widgetProps}
                breakpoint={breakpoint}
                index={index}
              />
            )
          })
        })
      }
      {
        (filterContent && size(filterContent) > 1) &&
        (compact(filterContent) || []).map((filter, index) => {
          return (
            <Dropdown show={openDropdownIndex === index} onToggle={() => handleToggle(index)} key={index}>
              <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components"
                widgetProps={widgetProps}
                breakpoint={breakpoint}
                index={index}
                filter={filter}
                contentLength={filterContent.length}
                onClick={(e) => { e.stopPropagation(); handleToggle(index); }}>
                {filter.name}
              </Dropdown.Toggle>

              <Dropdown.Menu as={CustomMenu}>
                <DropdownMenu widgetProps={widgetProps} filter={filter} breakpoint={breakpoint} />
              </Dropdown.Menu>
            </Dropdown>
          )
        })
      }

      {filterContent && size(filterContent) > 1 &&
        <RenderResetButton widgetProps={widgetProps} breakpoint={breakpoint}/>
      }
    </div>
  )
}

const RenderResetButton = ({ widgetProps, breakpoint }) => {

  const contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);
  const filters = get(contentWidget, 'filters', []);

  if (!filters || size(filters) == 0) {
    return null;
  }

  return (
    <Dropdown>
      <Dropdown.Toggle as={ResetButton} widgetProps={widgetProps}
        breakpoint={breakpoint} />
    </Dropdown>
  )
}

const ButtonTab = ({ filter, option, widgetProps, breakpoint }) => {

  const [state, setState] = useState({
    buttonStyle: {},
    hover: false
  })

  const contentContext = React.useContext(Content.Context);
  const contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);

  const filters = get(contentWidget, 'filters', []);
  const selectedFilter = filters.find(item => item.property.fieldId === filter.id);
  const selectedValue = selectedFilter && selectedFilter.value ? selectedFilter.value[0] : null;
  const selected = (filter.options || []).find(item => item.id === selectedValue) || { id: "all", option: "All" };

  const hoverStyle = getStyles(widgetProps, breakpoint, 'hover');
  const buttonTabStyle = selected.id == option.id ? hoverStyle : state.buttonStyle;

  useEffect(() => {
    const regularBtnStyle = getStyles(widgetProps, breakpoint, 'regular');

    setState((state) => {
      return {
        ...state,
        buttonStyle: regularBtnStyle,
      }
    })
  }, [breakpoint, widgetProps]);

  useEffect(() => {
    let updatedStyle = getStyles(widgetProps, breakpoint, state.hover ? 'hover' : 'regular');

    setState((state) => {
      return {
        ...state,
        buttonStyle: updatedStyle,
      }
    })
  }, [state.hover])

  const handleOnMouseOver = (hover) => {
    setState((state) => {
      return {
        ...state,
        hover: hover
      }
    })
  }

  const handleClick = (e) => {
    e.stopPropagation();

    var request = {
      property: {
        type: "CUSTOM_FIELD",
        fieldId: filter.id
      },
      operator: "IS",
      value: null
    }

    if (option && option.id !== 'all') {
      request = {
        ...request,
        value: [option.id]
      }
    }

    contentContext.updateFiltersInContenGrid(contentWidget.uid, request);
  }

  return (
    <div
      onMouseLeave={() => handleOnMouseOver(false)}
      onMouseEnter={() => handleOnMouseOver(true)}
      className={cx(styles.dropdownButton)}
      style={buttonTabStyle}
      onClick={handleClick}>
      <div className={cx(styles.filterMenuItem)}>
        <TruncatedTextWithTooltip content={option.value} className={styles.label} maxWidth={300} placement='top'/>
      </div>
    </div>
  )
};

const DropdownMenu = ({ widgetProps, filter, breakpoint }) => {

  const options = filter.multiselect ? filter.options : [{
    id: 'all',
    value: 'All'
  }, ...filter.options];

  return (
    <Fragment>
      {
        (options || []).map((option, index) => {
          return (
            <Dropdown.Item as={DropdownOption} key={index}
              widgetProps={widgetProps}
              breakpoint={breakpoint}
              filter={filter}
              option={option}
              index={index}
              />
          )
        })
      }
    </Fragment>
  )
} 

const CustomToggle = React.forwardRef(({ onClick, index, contentLength, breakpoint, widgetProps, filter }, ref) => {
  const [state, setState] = useState({
    buttonStyle: {},
    hover: false
  })

  const contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);
  const filters = get(contentWidget, 'filters', []);
  const selectedFilter = filters.find(item => item.property.fieldId === filter.id);
  const selecetdValue = selectedFilter && selectedFilter.value ? selectedFilter.value[0] : null;
  const selectedValues = selectedFilter && selectedFilter.value ? selectedFilter.value : null;
  const valueCount = size(selectedValues); 

  const selected = (filter.options || []).find(item => item.id === selecetdValue);

  useEffect(() => {
    const activeButtonStyle = getStyles(widgetProps, breakpoint, 'regular');
    setState((state) => {
      return {
        ...state,
        buttonStyle: activeButtonStyle,
      }
    })

  }, [breakpoint, widgetProps]);

  useEffect(() => {
    let updatedStyle = getStyles(widgetProps, breakpoint, state.hover ? 'hover' : 'regular');

    setState((state) => {
      return {
        ...state,
        buttonStyle: updatedStyle,
      }
    })
  }, [state.hover])

  const handleOnMouseOver = (hover) => {
    setState((state) => {
      return {
        ...state,
        hover: hover
      }
    })
  }

  return (
    <div
      onMouseLeave={() => handleOnMouseOver(false)}
      onMouseEnter={() => handleOnMouseOver(true)}
      className={cx(styles.dropdownButton, { [styles.lastButton]: index === contentLength - 1 && filters.length === 0 })}
      ref={ref}
      style={state.buttonStyle}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <div className={cx(styles.filterMenuItem, {
        [styles.selected]: selected != null
      })}>
        <TruncatedTextWithTooltip content={filter.name} className={styles.label} maxWidth={300} placement='top'/>
        <div className={styles.size}>
          <TruncatedTextWithTooltip content={get(selected, 'value')} className={styles.value} maxWidth={300} placement='top'/>
          {valueCount>1 &&
            <span className={styles.valueCount}> + {valueCount-1}</span>
          }
        </div>
      </div>
      <i className={cx('cleverstory-drop-down', styles.dropDownIcon, { [styles.showDropdown]: false })} />
    </div>
  )
});

const ResetButton = ({ breakpoint, widgetProps }) => {
  const [state, setState] = useState({
    buttonStyle: {},
    hover: false
  })

  const contentContext = React.useContext(Content.Context);

  const contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);
  const filters = get(contentWidget, 'filters', []);

  const handleOnMouseOver = (hover) => {
    setState((state) => {
      return {
        ...state,
        hover: hover
      }
    })
  }

  useEffect(() => {
    let updatedStyle = getStyles(widgetProps, breakpoint, state.hover ? 'hover' : 'regular');

    setState((state) => {
      return {
        ...state,
        buttonStyle: updatedStyle,
      }
    })
  }, [state.hover]);

  const handleResetClick = () => {
    contentContext.resetFiltersInContenGrid(contentWidget.uid);
  }

  if (!filters || filters.length === 0) {
    return null;
  }

  return (
    <div
      onMouseLeave={() => handleOnMouseOver(false)}
      onMouseEnter={() => handleOnMouseOver(true)}
      className={cx(styles.dropdownButton, styles.lastButton)}
      style={state.buttonStyle}
      onClick={(e) => {
        e.preventDefault();
        handleResetClick(e);
      }}
    >
      <div className={cx(styles.filterMenuItem)}>
        <div className={styles.label}>Reset</div>
      </div>
    </div>
  )
}

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const CustomMenu = React.forwardRef(
  ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
    const [value, setValue] = useState('');
    return (
      <div
        ref={ref}
        className={cx(className, styles.dropdownMenu)}
        aria-labelledby={labeledBy}
      >
        <div className="list-unstyled">
          {React.Children.toArray(children).filter(
            (child) =>
              !value || child.props.children.toLowerCase().startsWith(value),
          )}
        </div>
      </div>
    );
  },
);

const DropdownOption = ({ filter, option, index, widgetProps, breakpoint }) => {
  const contentContext = React.useContext(Content.Context);

  const [subFilterMenuStyle, setSubFilterMenuStyle] = useState(getDropDownStyles(widgetProps, 'regular', breakpoint, filter))
  const contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);

  const filters = get(contentWidget, 'filters', []);
  const valueObj = filters.find(item => item.property.fieldId === filter.id);
  const isOptionChecked = () => {
    return valueObj ? includes(valueObj.value, option.id) : false;
  };

  const handleSubMenuHover = (active) => {
    const updatedStyle = getDropDownStyles(widgetProps, active, breakpoint, filter);

    setSubFilterMenuStyle(updatedStyle)
  }

  const filterValue = (values, optionId) => {
    if (values.includes(optionId)) {
      return values.filter(id => id !== optionId);
    } 
      return [...values, optionId];
  }

  const handleClick = (e) => {
    e.stopPropagation();

    let values = (valueObj && valueObj.value) || [];
    const isMultiselect = filter.multiselect;
    const optionId = option && option.id !== 'all' ? option.id : null;
    let value = optionId != null ? [optionId] : null;

    if (isMultiselect) {
      value = filterValue(values, optionId);
      value = value.length === 0 ? null : value;
    }

    const request = {
        property: {
            type: "CUSTOM_FIELD",
            fieldId: filter.id
        },
        operator: "IS",
        value: value
    };

    if (!isMultiselect) {
        document.body.click();
    }
    contentContext.updateFiltersInContenGrid(contentWidget.uid, request);
  }

  return (
    <div
      style={subFilterMenuStyle}
      key={index}
      onMouseLeave={() => handleSubMenuHover('regular')}
      onMouseEnter={() => handleSubMenuHover('hover')}
      onClick={handleClick}
      className={styles.dropdownItem}
    >
      {
      filter.multiselect &&
        <Form.Group className={styles.checkboxLabel}>
        <Form.Check
          style={{ ...subFilterMenuStyle, padding: '0px'}}
          type="checkbox"
          checked={isOptionChecked()}
        />
        </Form.Group>
      }
      <TruncatedTextWithTooltip content={option.value} maxWidth={300} placement='top'/>
    </div>
  )
}

const filterDropdownEquals = function (prevProps, nextProps) {
  const paths = ['className', 'widgetProps', 'breakpoint', 'filterContent', 'active', 'alignment'];
  const next = pick(nextProps, paths);
  const previous = pick(prevProps, paths);

  const equals = isEqual(next, previous);
  return equals;
}

export const FilterDropdown = React.memo(FilterDropdownComponent, filterDropdownEquals);

/**
 * Generate Styles
*/
function getDropDownStyles(widgetProps, active, breakpoint, filter) {
  var styles = {};

  if (!widgetProps) {
    return styles;
  }

  const defaultProperties = get(widgetProps, `properties.desktop`);
  const defaultStyles = get(defaultProperties, `regular.filterStyles`, {});
  const deviceProperties = get(widgetProps, `properties.${breakpoint}`, {});

  //font-color
  const colorRgb = get(defaultProperties, `${active}.dropdownColor`, null);
  const color = getColorStyles(colorRgb);
  styles = {
    ...styles,
    color: color
  }

  //background
  const backgroundRgb = get(defaultProperties, `${active}.dropdownBackground`, null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = `rgba(${backgroundRgb.r}, ${backgroundRgb.g}, ${backgroundRgb.b}, ${backgroundRgb.a})`;
  }

  styles['backgroundColor'] = background;

  const font = get(defaultStyles, 'font', {});

  //font-family
  const fontFamily = get(font, 'fontFamily');

  if (fontFamily) {
    styles = {
      fontFamily: injectAktivFallback(fontFamily),
      ...styles,
    }
  } else {
    styles = {
      fontFamily: 'Montserrat, sans-serif',
      ...styles,
    }
  }

  //line Height
  const layoutHeight = get(defaultProperties, 'layout.height');
  if (layoutHeight) {
    styles['lineHeight'] = layoutHeight;
  }

  //font-style
  const bold = get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }

  const italic = get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }

  const underline = get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }

  //line spacing
  const lineSpacingString = get(defaultProperties, 'regular.filterStyles.font.lineSpacing', null);
  if (lineSpacingString) {
    const lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }

  //Letter Spacing
  const letterSpacingString = get(defaultProperties, 'regular.filterStyles.font.letterSpacing', null);
  if (letterSpacingString) {
    const letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }

  //font-size
  const fontSizeString = breakpoint === 'desktop' ? get(defaultProperties, `regular.filterStyles.font.fontSize`, null) : 14;
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }

  styles['fontSize'] = fontSize;
  styles['justifyContent'] = 'center';
  styles['textAlign'] = 'center';


  //border
  const border = get(defaultProperties, `${active}.dropdownBorder`, {});
  const borderColor = get(border, `color`, null);

  const borderStyle = getBorderStyles(border, borderColor);
  styles = {
    ...styles,
    ...borderStyle
  }

  // spacing & padding
  const spacing = get(defaultProperties, 'padding');
  let horizontalPadding = get(deviceProperties, 'itemHorizontalPadding');
  let verticalPadding = get(deviceProperties, 'itemVerticalPadding');

  if(horizontalPadding === 0 && verticalPadding === 0) {
    horizontalPadding = get(defaultProperties, 'itemHorizontalPadding');
    verticalPadding = get(defaultProperties, 'itemVerticalPadding');
  }

  styles = {
    ...styles,
    paddingLeft: `${horizontalPadding}px`,
    paddingRight: `${horizontalPadding}px`,
    paddingTop: `${verticalPadding}px`,
    paddingBottom: `${verticalPadding}px`
  }

  return styles;
}

function dropdownButtonWrapperStyles(widget, alignment, breakpoint) {
  var styles = {};

  if (!widget) {
    return styles;
  }

  const deviceProperties = get(widget, `properties.${breakpoint}`, {});
  const defaultProperties = get(widget, `properties.desktop`, {});
  // spacing & padding
  let spacing = get(deviceProperties, 'padding');
  const horizontalPadding = get(deviceProperties, 'itemHorizontalPadding');
  const verticalPadding = get(deviceProperties, 'itemVerticalPadding');

  if(horizontalPadding === 0 && verticalPadding === 0) {
    spacing = get(defaultProperties, 'padding');
  }

  // Apply default styles
  styles = {
    ...styles,
    ...alignment,
    paddingLeft: 0,
    paddingRight: 0,
    gridColumnGap: `${spacing}px`,
  };

  // Apply alignment styles only if breakpoint is 'mobile'
  if (breakpoint === 'mobile') {
    styles = {
      ...styles,
      ...alignment,
    };
  }

  return styles;
}

function getStyles(widget, breakpoint, active) {
  var styles = {};

  if (!widget) {
    return styles;
  }

  const defaultProperties = get(widget, `properties.desktop`, {});
  const deviceProperties = get(widget, `properties.${breakpoint}`, {});
  const defaultStyles = get(defaultProperties, `regular.filterStyles`, {});

  //font-color
  const colorRgb = get(defaultProperties, `${active}.filterStyles.font.color`, null);
  const color = getColorStyles(colorRgb);
  styles = {
    ...styles,
    color: color
  }

  //background
  const backgroundRgb = get(defaultProperties, `${active}.filterStyles.background`, null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = `rgba(${backgroundRgb.r}, ${backgroundRgb.g}, ${backgroundRgb.b}, ${backgroundRgb.a})`;
  }

  styles['backgroundColor'] = background;

  const font = get(defaultStyles, 'font', {});

  //font-family
  const fontFamily = get(font, 'fontFamily');
  if (fontFamily) {
    styles = {
      fontFamily: injectAktivFallback(fontFamily),
      ...styles,
    }
  } else {
    styles = {
      fontFamily: 'Montserrat, sans-serif',
      ...styles,
    }
  }

  //font-size
  const fontSizeString = get(deviceProperties, 'regular.filterStyles.font.fontSize', null);
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }

  styles['fontSize'] = fontSize;

  //Letter Spacing
  const letterSpacingString = get(deviceProperties, 'regular.filterStyles.font.letterSpacing', null);
  if (letterSpacingString) {
    const letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }

  //line Height
  const layoutHeight = get(deviceProperties, 'layout.height');
  if (layoutHeight && breakpoint === 'desktop') {
    styles['lineHeight'] = layoutHeight;
  }

  //line spacing
  const lineSpacingString = get(deviceProperties, 'regular.filterStyles.font.lineSpacing', null);
  if (lineSpacingString) {
    const lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }


  //font-style
  const bold = get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }

  const italic = get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }

  const underline = get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }

  //border
  const border = get(defaultProperties, `${active}.filterStyles.border`, {});
  const borderColor = get(defaultProperties, `${active}.filterStyles.border.color`, null);

  const borderStyle = getBorderStyles(border, borderColor);
  styles = {
    ...styles,
    ...borderStyle
  }

  // spacing & padding
  const spacing = get(defaultProperties, 'padding');
  let horizontalPadding = get(deviceProperties, 'itemHorizontalPadding');
  let verticalPadding = get(deviceProperties, 'itemVerticalPadding');

  if(horizontalPadding === 0 && verticalPadding === 0) {
    horizontalPadding = get(defaultProperties, 'itemHorizontalPadding');
    verticalPadding = get(defaultProperties, 'itemVerticalPadding');
  }

  styles = {
    ...styles,
    paddingLeft: `${horizontalPadding}px`,
    paddingRight: `${horizontalPadding}px`,
    paddingTop: `${verticalPadding}px`,
    paddingBottom: `${verticalPadding}px`
  }


  //alignment
  const alignment = get(deviceProperties, 'alignment', {});

  var position = get(alignment, 'position', 'center');
  styles['justifyContent'] = position;
  styles['textAlign'] = position;

  var margin = get(alignment, 'margin', 0);
  if (position === 'left') {
    styles = {
      ...styles,
      paddingLeft: `${margin}px`
    }
  } else if (position === 'right') {
    styles = {
      ...styles,
      paddingRight: `${margin}px`
    }
  }

  return styles;
}

export function getColorStyles(value) {
  if (!value) {
    return null;
  }

  const colorRgb = value;

  var color = 'inherit';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  return color;
}

export function getBorderStyles(value, colorRgb) {
  if (!value) {
    return null;
  }

  var styles = {};
  const topLeft = get(value, 'radius.topLeft', null);
  const topRight = get(value, 'radius.topRight', null);
  const bottomLeft = get(value, 'radius.bottomLeft', null);
  const bottomRight = get(value, 'radius.bottomRight', null);

  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }

  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }

  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }

  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }

  var color = 'transparent';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  styles['borderColor'] = color;

  const borderWidthString = get(value, 'width', null);
  var borderWidget = parseInt(borderWidthString) + 'px';

  styles['borderWidth'] = borderWidget;

  return styles;
}